import iso3166 from 'iso-3166-2'

function getCountries () {
    const countries = []
    Object.keys(iso3166.data).forEach((countryCode) => {
        const country = iso3166.data[countryCode]
        countries.push({
            code: countryCode,
            name: country.name
        })
    })

    countries.sort((a, b) => {
        const countryNameA = a.name.toLowerCase()
        const countryNameB = b.name.toLowerCase()
        if (countryNameA < countryNameB) return -1
        if (countryNameA > countryNameB) return 1
        return 0
    })
    return countries
}

function getRegions (countryCode) {
    if (!(countryCode in iso3166.data)) return null
    const regions = []
    const country = iso3166.data[countryCode]

    Object.keys(country.sub).forEach((regionCode) => {
        const region = country.sub[regionCode]
        regions.push({
            code: regionCode.split('-')[1],
            name: region.name,
            type: region.type
        })
    })

    regions.sort((a, b) => {
        const regionNameA = a.name.toLowerCase()
        const regionNameB = b.name.toLowerCase()
        if (regionNameA < regionNameB) return -1
        if (regionNameA > regionNameB) return 1
        return 0
    })
    return regions
}

export default {
    getCountries,
    getRegions
}
